import { connect, ConnectedProps } from "react-redux";
import { PayFlexSurvey } from "./component";
import { IStoreState } from "../../../../reducers/types";
import {
  getApplicableCredit,
  getPayFlexCardProductUsed,
  getTotalCreditCardPaymentRequiredNumber,
  getTotalToPay,
  getRewardsPaymentInFiatCurrency,
} from "../../reducer";

const mapStateToProps = (state: IStoreState) => {
  const totalToPay = getTotalToPay(state);
  const rewardsPayment = getRewardsPaymentInFiatCurrency(state);
  const applicableCredit = getApplicableCredit(state);

  return {
    netCashValueP: getTotalCreditCardPaymentRequiredNumber(state) ?? 0,
    totalAmountUsd: totalToPay?.fiat.value ?? 0,
    rewardsAmountUsd: rewardsPayment?.value ?? 0,
    creditsAmountUsd: applicableCredit?.amount.amount ?? 0,
    cardProductUsed: getPayFlexCardProductUsed(state),
  };
};

const connector = connect(mapStateToProps);

export type PayFlexSurveyConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedPayFlexSurvey = connector(PayFlexSurvey);
